import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ID } from '@datorama/akita';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';

import { applyValues } from '@helpers/objects';
import { Form, FormSection } from '@state/form';
import { FormsService } from '@state/forms';
import { standardError } from '@helpers/error';
import { uuidPattern } from '@helpers/validation-patterns';

export interface ImportSectionsModalData {
  forms: Form[];
  id: ID;
}
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-import-sections-modal',
  styleUrls: ['./import-sections-modal.component.scss'],
  templateUrl: './import-sections-modal.component.html'
})
export class ImportSectionsModalComponent implements OnInit {
  customFormId: ID;
  customForm: Form;
  formImport: Partial<Form> = { id: 'import', title: 'import' };
  forms: Form[];
  form_id: ID;
  saving = false;
  sectionSelections: FormSection[] = [];
  sections: FormSection[];
  selectedForm: Form | Partial<Form>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ImportSectionsModalData,
    private dialog: MatDialogRef<ImportSectionsModalComponent>,
    private formsService: FormsService
  ) {}

  ngOnInit() {
    applyValues({ data: this.data, keys: ['form_id', 'forms'], obj: this });
  }

  @HostListener('window:keyup.esc')
  close(): void {
    this.dialog.close();
  }

  get validFormID(): boolean {
    let id = this.customFormId as string;
    return id && uuidPattern.test(id);
  }

  getCustomForm(): void {
    if (!this.validFormID) return;

    this.formsService.getForm$(this.customFormId).subscribe({
      error: (error: HttpErrorResponse) => standardError(error),
      next: (form) => {
        this.customForm = form;
        this.sections = form.sections;
      }
    });
  }

  getSections(change: MatSelectChange): void {
    delete this.sections;

    let { id }: { id: string } = change.value;
    if (id === 'import') return;

    this.formsService.getForm$(id).subscribe({
      error: (error: HttpErrorResponse) => standardError(error),
      next: (form) => (this.sections = form.sections)
    });
  }

  importSections(): void {
    if (this.saving) return;
    this.saving = true;

    let { form_id, sectionSelections } = this;
    let section_ids = sectionSelections.map((section) => section.id);

    this.formsService.importSections$({ form_id, section_ids }).subscribe({
      error: (error: HttpErrorResponse) => {
        this.saving = false;
        standardError(error);
      },
      next: (form: Form) => this.dialog.close(form)
    });
  }
}
